/**
 *  tab4 4.0
 *  @version: 4.0
 *  @author: Ryan
 *  Update: 2021.02.18
 *  Last Coding: Ryan, 2021.02.18
 *  
 *  use plugin : 
 *  jquery-3.4.1.js
 */

;
(function($) {
  'use strict';

  let Tab4 = function(container, options) {
    this.container = $(container);
    this.options = $.extend({}, Tab4.DEFAULTS ,options);
    this.elements = getDataEl(this);
    this.unicode = Math.floor(new Date());
    // 呼叫
    tabInit(this);
    tabDetect(this);
    // 第一次近來呼叫
    // if(this.options.callback && {}.toString.call(this.options.callback) === '[object Function]') this.options.callback();
  };

  // 啟動事件
  let tabInit = function(el) {
    let _this = el;
    let nowButton = '';
    let nowPage = '';
    // 標記
    _this.container.addClass('tab4-init');
    // 洗出頁數
    _this.elements.parents.each((i,single) => {
      $(single).find('[data-tab-page]').each((i,el) => {
        $(el).attr('data-tab-no', i+1);
      });
    });

    // 洗出目標class
    nowPage = _this.container.find('.tab-now[data-tab-page]');
    nowButton = _this.container.find(`[data-tab-id = ${nowPage.attr('data-tab-page')}]`);
    nowPage.addClass('tab-now');
    nowButton.addClass('tab-now');

    // 綁點擊事件
    _this.elements.buttons.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function(e) {
      e.preventDefault();
      let target = $(this).attr('data-tab-id');
      tabToChange(_this.container, target, _this.options.callback);
    });

    _this.elements.jump.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function(e) {
      e.preventDefault();
      let target = $(this).attr('data-tab-jump');
      tabToChange(_this.container, target, _this.options.callback);
    });

    _this.elements.prev.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function(e) {
      e.preventDefault();
      tabToPrev(_this.container, _this.options.callback);
    });

    _this.elements.next.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function(e) {
      e.preventDefault();
      tabToNext(_this.container, _this.options.callback);
    })
  };

  // 偵測options
  let tabDetect = function(el) {
    let _this = el;
    let options = _this.options;
    if(options.rwdPoint !== '') {
      if(options.rwdPoint === false) return;
      let nowPoint = options.rwdPoint;
      if(nowPoint === true || isNaN(nowPoint) || nowPoint === undefined || !nowPoint) {
        nowPoint = 767
      };
      nowPoint = Number(nowPoint);
      let rwdEvent = function() {
        let screenWidth = window.innerWidth;
        if(screenWidth <= nowPoint) {
          _this.container.addClass('tab-rwd-mode');
          tabSlide(_this);
        }
        else {
          _this.container.removeClass('tab-rwd-mode');
          tabSlideOff(_this);
        };
      };
      $(window).on('resize load', function() {
        rwdEvent();
      });
      rwdEvent();
    };
  };

  let getDataEl = function(el) {
    let _this = el
    let obj = {
      parents: _this.container.find('[data-tab-page]').parent(),
      buttons: _this.container.find('[data-tab-id]'),
      pages: _this.container.find('[data-tab-page]'),
      jump: _this.container.find('[data-tab-jump]'),
      prev: _this.container.find('[data-tab-prev]'),
      next: _this.container.find('[data-tab-next]'),
    }
    return obj
  };

  let tabSlide = function(el) {
    let _this = el
    let container = _this.container
    let val = $(container).find('.val');
    let allVal = $(container).find('.tab-link .all-val');
    let slide = $(container).find('.links-box');
    let clickTarget = $(container).find('.tab-wrap');
    let icon = $(container).find('.icon-inner');
    let test = false;
    let close = function() {
      test = false;
      slide.slideUp(500);
      icon.removeClass('act');
    };
    clickTarget.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function(e) {
      e.stopPropagation();
      test = true;
      if(test === false) return;
      slide.slideDown(500);
      icon.addClass('act');

      allVal.off(`click.${_this.unicode}`).on(`click.${_this.unicode}`, function() {
        val.text('').text($(this).text())
        close()
      })
    });
    slide.on(`click.${_this.unicode}`, function(e) {
      e.stopPropagation()
    });
    $('body').on(`click.${_this.unicode}`, function() {
      close();
    });
    slide.css('display', "none");
    icon.removeClass('act');

    // 綁定卷軸套件
    container.find('.tab-links').addClass('scrollbar-inner');
    setTimeout(() => {
      if(container.find('.tab-links').hasClass('scrollbar-inner')) {
        container.find('.scrollbar-inner').scrollbar();
      };
    }, 300);

  };

  let tabSlideOff = function(el) {
    let _this = el;
    let container = _this.container;
    let allVal = $(container).find('.tab-link .all-val');
    let slide = $(container).find('.links-box');
    let clickTarget = $(container).find('.tab-wrap');
    let icon = $(container).find('.icon-inner');
    allVal.off(`click.${_this.unicode}`);
    slide.off(`click.${_this.unicode}`);
    clickTarget.off(`click.${_this.unicode}`);
    $('body').off(`click.${_this.unicode}`);
    slide.css('display', "block");
    icon.removeClass('act');
  };

  Tab4.DEFAULTS = {
    // rwd斷點
    rwdPoint: '',
    // 完成後事件
    callback: '',
  };

  let tabToChange = function(container, target, callback) {

    let allButtons = container.find('[data-tab-id]');
    let allPages = container.find('[data-tab-page]');

    let pages = [];
    allPages.each((index, page) => {
      pages.push($(page).attr('data-tab-page'));
    });
    if(pages.indexOf(target) == -1) return;

    let nowButton = container.find(`[data-tab-id = "${target}"]`);
    let nowPage = container.find(`[data-tab-page = "${target}"]`);
    if(nowPage.hasClass('tab-now')) return;

    let promise = function() {
      return new Promise((resolve, reject) => {
        allButtons.removeClass('tab-now');
        allPages.removeClass('tab-now');
        allPages.hide();
        nowButton.addClass('tab-now');
        nowPage.addClass('tab-now');
        nowPage.fadeIn(350);
        setTimeout(() => {
          resolve();
        }, 400)
      })
    };

    promise().then(function () {
      if(callback && {}.toString.call(callback) === '[object Function]') callback();
    });

  };

  let tabToPrev = function(container, callback) {
    let nowNo = container.find(".tab-now[data-tab-page]").attr('data-tab-no');
    let n = /^-[0-9]*[1-9][0-9]*$/;  // 負整數
    let prevNo = Number(nowNo) - 1;
    if(prevNo === 0 || n.test(prevNo) === true) return;
    let target = container.find(`[data-tab-no = ${prevNo}]`).attr('data-tab-page');
    tabToChange(container, target, callback);
  };

  let tabToNext = function(container, callback) {
    let nowNo = container.find(".tab-now[data-tab-page]").attr('data-tab-no');
    let allLength = container.find('[data-tab-page]').length;
    let nextNo = Number(nowNo) + 1;
    if(nextNo === 0 || nextNo > allLength) return;
    let target = container.find(`[data-tab-no = ${nextNo}]`).attr('data-tab-page');
    tabToChange(container, target, callback);
  };

  $.fn.tab4 = function(options) {
    if(typeof options !== 'object' ||  options === undefined) {
      options = {};
    };
    let tabs = {};
    const vm = this;
    for (let i = 0; i < $(vm).length; i++) {
      tabs[i] = new Tab4($(vm)[i], options);
    };
  };

  $.fn.tab4Change = function(target, callback = null) {
    let container = this
    switch (target) {
      case 'prev':
        tabToPrev(container, callback);
        break;
      case 'next':
        tabToNext(container, callback);
        break;
      default:
        tabToChange(container, target, callback);
        break;
    };
  };

})(jQuery);
